/**
 * NoteService.js
 *
 * Provides functions to add a note and fetch notes by user ID.
 * Uses the generic API utility for HTTP requests.
 */

import { api } from '@/services/httpCall';
import { POST, GET } from '@/shared/constants/httpMethods';

/**
 * Adds a note for a specific user.
 * @param {Object} params - The note parameters.
 * @param {string|number} params.userId - The user ID.
 * @param {string} params.content - The note content.
 * @returns {Promise<{userId: string|number, content: string}|null>} The note if successful, otherwise null.
 */
export const addNote = async ({ userId, content }) => {
  const response = await api(POST, '/admin/note', { userId, content });
  if (response.statusCode === 200) return { userId, content };
  return null;
};

/**
 * Fetches all notes for a specific user by user ID.
 * @param {string|number} userId - The user ID.
 * @returns {Promise<Array>} Array of notes if successful, otherwise empty array.
 */
export const getNotesByUserId = async (userId) => {
  const response = await api(GET, `/admin/note/user/${userId}`);
  if (response.statusCode === 200) return response.data;
  return [];
};
